import React, { Component } from "react";
import LiveOrderStreamPanel from './live_order_stream_panel/live_order_stream_panel';
import HallPanel from './shop_panel/hall_panel'
import HallPanelVerticalLayout from './shop_panel/hall_panel_vertical_layout';
import HallPanelPromo from './shop_panel/hall_panel_promo_only';
import {inject, observer} from 'mobx-react';
import Flexbox from 'flexbox-react'
import ReactInterval from 'react-interval';
import MediaQuery from 'react-responsive';
import LiveOrderStreamWidget from "./order_stream_widget/live_order_stream_widget";
import LiveOrderStreamWidgetShopClosed from './live_order_stream_panel/live_order_stream_widget_shop_closed';
import {CONNECTION_ISSUE_FLAG} from "../constants";


const horizontalMainPage = {
    minWidth: "1920px",
    minHeight: "1080px",
    height: "100vh",
    width: "178vh",
};

const verticalMainPage = {
    minWidth:"1080px",
    minHeight:"1920px",
    height:"100vh",
    width:"56.25vh"
};

function newDisplayWidget(isShopOpen) {
  //set the correct widget, open or closed
  if(isShopOpen) {
      return <LiveOrderStreamWidget/>;
  } else {
      return <LiveOrderStreamWidgetShopClosed/>;
  }
}

function hallPanelVerticalShopList(shopCount){
    if(shopCount === 0) {
        return '';
    } else if(shopCount <= 2) {
        return <HallPanelVerticalLayout mainHeight="17.5%"/>;
    } else if (shopCount <= 4) {
        return <HallPanelVerticalLayout mainHeight="27.5%"/>;
    } else {
        return <HallPanelVerticalLayout mainHeight="34.5%"/>;
    }
}

function getCurrHallPanel(isPromo){
    return isPromo ? <HallPanelPromo/> : <HallPanel/>;
}

@inject('RootStore')
@observer
export default class ShopPage extends Component {
    render() {
        let {configStore, hallStore, styleStore} = this.props.RootStore;
        const isDisplayConnectionIssue = configStore.displayAlert === CONNECTION_ISSUE_FLAG
        let hallPanel = getCurrHallPanel(configStore.usePromo);
        const displayWidget = newDisplayWidget(configStore.isShopOpen);
        configStore.calcIsVertical();
        let hallPanelVertical = hallPanelVerticalShopList(hallStore.shopListLength);

        return (
            <div style={{width: "100%", height: "100%"}}>
                <MediaQuery query="(orientation: landscape)">
                    <Flexbox style={horizontalMainPage} flexDirection='row'>
                        <Flexbox width="66%" height="100%" flexDirection='column'>
                            <Flexbox justifyContent={'center'} height={styleStore.currentLiveStreamOrderStyle.panelHeight}>
                                  <LiveOrderStreamPanel/>
                            </Flexbox>
                            <Flexbox height={styleStore.currentLiveStreamOrderStyle.widgetHeight}
                                     style={{"visibility": isDisplayConnectionIssue ? "hidden" : "visible"}}>
                                {displayWidget}
                            </Flexbox>
                        </Flexbox>

                        <Flexbox width="34%" height="100%">
                            {hallPanel}
                        </Flexbox>

                        <ReactInterval
                             timeout={hallStore.paginationRate} enabled={true}
                             callback={() => hallStore.paginateShopListData()}
                        />
                    </Flexbox>
                </MediaQuery>
                <MediaQuery query="(orientation: portrait)">
                    <Flexbox style={verticalMainPage} flexDirection='column'>
                        <Flexbox width="100%" justifyContent="center" height={styleStore.currentLiveStreamOrderStyle.panelHeight}>
                            <LiveOrderStreamPanel/>
                        </Flexbox>
                        <Flexbox height={styleStore.currentLiveStreamOrderStyle.widgetHeight} flexDirection="column">
                            <Flexbox width="100%" height="50%" flexGrow={1} style={{"visibility": isDisplayConnectionIssue ? "hidden" : "visible"}}>
                                {displayWidget}
                            </Flexbox>
                            {hallPanelVertical}
                        </Flexbox>

                    </Flexbox>
                </MediaQuery>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/shop_page.jsx